import { SmartLinkStats } from "@/services/bedrock";

export const generateTabs = (stats: SmartLinkStats) => {
  const tabs = [];
  if (stats.clicksByDay) {
    tabs.push({
      name: "Performance Over Time",
      data: stats.clicksByDay.map(d => ({ Date: d.date, Clicks: d.count })),
      desc: "Click volume trends aggregated by day.",
    });
  }

  if (stats.clicksByNetwork) {
    tabs.push({
      name: "Social Networks",
      data: stats.clicksByNetwork.map(d => ({ Network: d.network, Clicks: d.count })),
      desc: "Distribution of clicks across different social platforms.",
    });
  }

  if (stats.clicksByPlayer) {
    tabs.push({
      name: "Player Attribution",
      data: stats.clicksByPlayer.map(d => ({
        Player: d.playerName,
        Email: d.playerEmail,
        InternalId: d.playerInternalId,
        Clicks: d.count,
      })),
      desc: "Performance breakdown by individual team members.",
    });
  }

  if (stats.clicksByRegion) {
    tabs.push({
      name: "Geographic Regions",
      data: stats.clicksByRegion.map(d => ({
        Country: d.country || "Unknown",
        State: d.state || "Unknown",
        Clicks: d.count,
      })),
      desc: "Audience location breakdown by state and country.",
    });
  }

  if (stats.clicksByCampaign) {
    tabs.push({
      name: "Campaign Attribution",
      data: stats.clicksByCampaign.map(d => ({ Campaign: d.campaignName, Clicks: d.count })),
      desc: "Clicks attributed to specific high-level campaigns.",
    });
  }

  if (stats.clicksByPrompt) {
    tabs.push({
      name: "Prompt Attribution",
      data: stats.clicksByPrompt.map(d => ({ Prompt: d.promptTitle, Clicks: d.count })),
      desc: "Clicks attributed to individual social prompts.",
    });
  }

  if (stats.clicksBySmartLink) {
    tabs.push({
      name: "Link Attribution",
      data: stats.clicksBySmartLink.map(d => ({ SmartLink: d.smartLinkName, Clicks: d.count })),
      desc: "Clicks attributed to individual links.",
    });
  }

  return tabs;
};
